import { styled, Button } from "@mui/material";

const StyledPrimaryButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.widgetStyles.button.primary.backgroundColor,
  color: theme.palette.widgetStyles.button.primary.textColor,
  borderRadius: "52px",
  textTransform: "none",
  minHeight: "44px",
  fontWeight: "600",
  fontSize: "17px",
  boxShadow: "none",
  lineHeight: "22px",

  "&:hover": {
    backgroundColor: theme.palette.widgetStyles.button.primary.hoverColor,
    borderColor: theme.palette.widgetStyles.button.primary.hoverColor,
    boxShadow: "none",
  },
}));

export default StyledPrimaryButton;
